import StoreProfilePage from './StoreProfilePage'

export default StoreProfilePage
